import { render, staticRenderFns } from "./PdfView.vue?vue&type=template&id=0115f95d&"
import script from "./PdfView.vue?vue&type=script&lang=ts&"
export * from "./PdfView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports